import React, { useState } from 'react';
import { FaCheck, FaChevronDown } from 'react-icons/fa';

export default function FeatureList({ features, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const preview = features.slice(0, 3);
  const rest = features.slice(3);
  const hasMore = rest.length > 0;

  return (
    <div>
      <p
        className="text-sm font-semibold mb-4 uppercase tracking-wider"
        style={{ fontFamily: "'Poppins', sans-serif", color: '#ff7a59' }}
      >
        What you get
      </p>
      <ul className="space-y-2.5">
        {preview.map((feature) => (
          <li
            key={feature}
            className="flex items-start gap-3 text-sm"
            style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
          >
            <FaCheck className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#ff7a59' }} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      {hasMore && (
        <>
          <div
            className={`overflow-hidden transition-all duration-500 ease-out ${
              open ? 'max-h-[800px] opacity-100 mt-2.5' : 'max-h-0 opacity-0'
            }`}
          >
            <ul className="space-y-2.5">
              {rest.map((feature) => (
                <li
                  key={feature}
                  className="flex items-start gap-3 text-sm"
                  style={{ fontFamily: "'Poppins', sans-serif", color: '#292929' }}
                >
                  <FaCheck className="w-4 h-4 mt-0.5 flex-shrink-0" style={{ color: '#ff7a59' }} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="mt-4 inline-flex items-center gap-2 text-sm font-medium transition-colors hover:opacity-80"
            style={{ fontFamily: "'Poppins', sans-serif", color: '#ff7a59' }}
          >
            {open ? 'Show less' : `See all ${features.length} included`}
            <FaChevronDown
              className={`w-3 h-3 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
            />
          </button>
        </>
      )}
    </div>
  );
}
